// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-966f7b10","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./components/LumiNavbarLink.vue
// module id = 52
// module chunks = 0